var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',[_c('vs-col',{attrs:{"vs-w":"12"}},[_c('vs-card',{staticStyle:{"padding":"10px"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h2',[_vm._v("Referrals Page")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }